<script lang="ts">
  import { Container, Row } from 'sveltestrap';
  import {drabbleCardData} from "../../../Data/BonusUi/Drabblecard"
  import { flip } from 'svelte/animate'
  import BookmarkDraggablecard from './BookmarkDraggablecard.svelte';
  import Card from '../../Ui-Kits/UiCommenCard.svelte';
    const dragDuration:number = 300
    let draggingCard:any
    let animatingCards:any = new Set()
    function swapWith(card:any) {
        if (draggingCard === card || animatingCards.has(card)) return
        animatingCards.add(card)
        setTimeout(() => animatingCards.delete(card), dragDuration)
        const cardAIndex = drabbleCardData.indexOf(draggingCard)
        const cardBIndex = drabbleCardData.indexOf(card)
        drabbleCardData[cardAIndex] = card
        drabbleCardData[cardBIndex] = draggingCard
    }
</script>
<BookmarkDraggablecard />
<Container fluid>
    <Row class="ui-sortable" id="draggableMultiple">
        {#each drabbleCardData as drabbleCardItem ,index(drabbleCardItem)}
            <div class="col-sm-12 col-xl-6"
                id={index.toString()}
                animate:flip={{ duration : dragDuration }}
                draggable="true"
                on:dragstart={() => draggingCard = drabbleCardItem}
                on:dragend={() => draggingCard = undefined}
                on:dragenter={() => swapWith(drabbleCardItem)}
                on:dragover|preventDefault
            >
                <Card cardProps={drabbleCardItem.cardclass} cardHeader2props="pb-0" >
                    <div slot="customHeader2">
                        <h5>
                            {#if drabbleCardItem.icon}
                                <i class="{drabbleCardItem.icon} me-2"></i>
                            {/if} {drabbleCardItem.header}
                        </h5>
                        {#if drabbleCardItem.subheader}
                            <span>{@html drabbleCardItem.subheader}</span>
                        {/if}
                    </div>
                    <div slot="contentbody">
                        <p class={drabbleCardItem.pclass}>{drabbleCardItem.detail}</p>
                    </div>
                </Card>
            </div>
        {/each}
    </Row>
</Container>
